/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_What_LabelInputs */

const en_directory_search_what_label = /** @type {(inputs: Directory_Search_What_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are you looking for?`)
};

const pl_directory_search_what_label = /** @type {(inputs: Directory_Search_What_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czego szukasz?`)
};

/**
* | output |
* | --- |
* | "What are you looking for?" |
*
* @param {Directory_Search_What_LabelInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_search_what_label = /** @type {((inputs?: Directory_Search_What_LabelInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_What_LabelInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_search_what_label(inputs)
	return en_directory_search_what_label(inputs)
});